import { styled } from '@mui/material/styles';
import { IDivider } from './types';

export const DividerStyle = styled('hr')<IDivider>`
  width: ${({ fullWidth, width }) => (fullWidth ? '100%' : width)};
  align-self: flex-end;
  background: ${({ theme }) => theme.palette.neutral.var30};
`;
